var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.34545 0 0 5.34545 0 12C0 18.6545 5.34545 24 12 24C18.6545 24 24 18.6545 24 12C24 5.34545 18.6545 0 12 0ZM14.1818 17.4545C14.1818 18.6545 13.2 19.6364 12 19.6364C10.8 19.6364 9.81818 18.6545 9.81818 17.4545V12.5455C9.81818 11.3455 10.8 10.3636 12 10.3636C13.2 10.3636 14.1818 11.3455 14.1818 12.5455V17.4545ZM12 7.63636C10.8 7.63636 9.81818 6.65455 9.81818 5.45455C9.81818 4.25455 10.8 3.27273 12 3.27273C13.2 3.27273 14.1818 4.25455 14.1818 5.45455C14.1818 6.65455 13.2 7.63636 12 7.63636Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7a64bebbcb6b2b7f992b5740a87ae0d4.svg";
export { ForwardRef as ReactComponent };